import Repository from "./api_v1";
import store from "../store/index";

const resource = "/api/dev/v1";

export default {
  //APIの一覧を記載
  //
  async get() {
    const { data } = await this.API_Get(resource + "/project/home");
    return data;
  },
  //Formデータの取得
  async GetForm(data) {
    let result = await this.API_Post(data, resource + "/form");
    return result;
  },
  async GetFormV2(data) {
    let result = await this.API_Post(data, resource + "/formV2");
    return result;
  },
  //Formデータの登録
  async RegForm(data, id) {
    let URL = "/report/create";
    if (id == "") {
      URL = "/reg";
    }
    await this.API_Post(data, resource + URL);
    return true;
  },
  //コンポーネント生成
  async componentGenerate(data) {
    let result = await this.API_Post(data, resource + "/generate");
    return result;
  },
  async gitPush(data) {
    let result = await this.API_Post(data, resource + "/deploy");
    return result;
  },
  async getCustomer() {
    const result = await this.API_Get(resource + "/customer");
    return result;
  },
  async getPage() {
    const result = await this.API_Get(
      resource + "/page/" + store.state.customerID
    );
    return result;
  },
  async getRouter() {
    const result = await this.API_Get(
      resource + "/router/" + store.state.customerID
    );
    return result;
  },
  async PageCreate(data) {
    const result = await this.API_Post(data, resource + "/page");
    return result;
  },
  async AllGenerate(data) {
    const result = await this.API_Post(data, resource + "/generate/router");
    return result;
  },
  async AllDeploy(data) {
    const result = await this.API_Post(data, resource + "/deploy/all");
    return result;
  },
  async getAllCustomer() {
    const result = await this.API_Get(resource + "/customer/all");
    return result;
  },
  async getJoinDeveloper(data) {
    const result = await this.API_Get(resource + "/customer/setting/" + data);
    return result;
  },
  async regJoinDeveloper(data) {
    const result = await this.API_Post(data, resource + "/customer/reg");
    return result;
  },
  async cusotmerGenerate(data) {
    const result = await this.API_Post(data, resource + "/customer/create");
    return result.data;
  },
  async CustomerCopy(data) {
    const result = await this.API_Post(data, resource + "/customer/copy");
    return result.data;
  },
  async employeesGenerate(data) {
    const result = await this.API_Post(data, resource + "/employee/reg");
    return result.data;
  },
  async ProductionTransition(data) {
    const result = await this.API_Post(
      data,
      resource + "/production/transition"
    );
    return result.data;
  },
  //情報取得
  async GetNoCountFormType() {
    const result = await this.API_Get(resource + "/get/noCountFormType");
    return result;
  },
  //分析
  async EmployeeLastLogin(data) {
    const result = await this.API_Post(data, resource + "/analysis/lastLogin");
    return result.data;
  },
  async AnalysisFormID(fromID) {
    const result = await this.API_Get(resource + "/analysis/formID/" + fromID);
    return result;
  },
  async AnalysisPageID(pageID) {
    const result = await this.API_Get(resource + "/analysis/pageID/" + pageID);
    return result;
  },
  //---------------------------------------------------
  async API_Get(URL) {
    Repository.interceptors.request.use(function(config) {
      //config.headers.Authorization = `Bearer ${store.state.accessToken}`
      config.headers.Authorization = `Bearer ${store.state.accessToken}`;
      return config;
    });
    const { data } = await Repository.get(URL, { timeout: 60000 }).catch(
      function(error) {
        const errorMessage = error.response.data || error.message;
        console.log("Get:", errorMessage);
        return false;
      }
    );
    return data;
  },
  async API_Post(data, URL) {
    let result = await Repository.post(URL, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${store.state.accessToken}`,
      },
      timeout: 60000,
    }).catch(function(error) {
      const errorMessage = error.response.data || error.message;
      console.log("Post:", errorMessage);
      return false;
    });
    return result;
  },
};
